var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jackpot-physical-help-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm._m(7),
      _vm._m(8),
      _c("div", { staticClass: "h1" }, [_vm._v("Điều khoản và điều kiện")]),
      _vm._m(9),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-md" }, [
      _c("strong", { staticClass: "text-white text-uppercase" }, [
        _vm._v("Thanh toán ngay lập tức:"),
      ]),
      _vm._v(" Nhận được khi thu thập được các vé Jackpot "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticStyle: { "list-style-type": "none" } }, [
      _c("li", { staticClass: "flex-center" }, [
        _c("span", { staticClass: "flex-center w-100" }, [
          _c("img", {
            staticClass: "img-small",
            attrs: { src: require("@/assets/images/mini-ticket.webp") },
          }),
          _c(
            "span",
            {
              staticStyle: { color: "#29ffff", "text-transform": "uppercase" },
            },
            [_vm._v("Mini ")]
          ),
        ]),
        _c("span", [
          _vm._v("Bạn có thể kiếm được tới "),
          _c("strong", [_vm._v("$50 USD")]),
        ]),
      ]),
      _c("li", { staticClass: "flex-center" }, [
        _c("span", { staticClass: "flex-center w-100" }, [
          _c("img", {
            staticClass: "img-small",
            attrs: { src: require("@/assets/images/minor-ticket.webp") },
          }),
          _c(
            "span",
            {
              staticStyle: { color: "#5ce386", "text-transform": "uppercase" },
            },
            [_vm._v("Minor ")]
          ),
        ]),
        _c("span", [
          _vm._v("Bạn có thể kiếm được tới "),
          _c("strong", [_vm._v("$250 USD")]),
        ]),
      ]),
      _c("li", { staticClass: "flex-center" }, [
        _c("span", { staticClass: "flex-center w-100" }, [
          _c("img", {
            staticClass: "img-small",
            attrs: { src: require("@/assets/images/major-ticket.webp") },
          }),
          _c(
            "span",
            {
              staticStyle: { color: "#ff6f8b", "text-transform": "uppercase" },
            },
            [_vm._v("Major ")]
          ),
        ]),
        _c("span", [
          _vm._v("Bạn có thể kiếm được tới "),
          _c("strong", [_vm._v("$500 USD")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-md" }, [
      _c("strong", { staticClass: "text-white text-uppercase" }, [
        _vm._v("Rút thăm may mắn:"),
      ]),
      _vm._v(" Giải thưởng được trao trong mỗi lần rút thăm "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-header major" }, [
      _c("div", [_vm._v("Phần thưởng Major:")]),
      _c("div", [_vm._v("có 1 giải")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-content" }, [
      _c("div", { staticClass: "prize-content-left" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/major-gold.webp"),
          },
        }),
        _c("div", [_vm._v("Vàng Doji 999.9 (18.75g)")]),
      ]),
      _c("div", { staticClass: "prize-content-mid" }, [_vm._v("HOẶC")]),
      _c("div", { staticClass: "prize-content-right" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/major-prize.webp"),
          },
        }),
        _c("div", [_vm._v("Iphone 15 Pro max (256gb)")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-header minor" }, [
      _c("div", [_vm._v("Phần thưởng Minor:")]),
      _c("div", [_vm._v("có 3 giải")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-content" }, [
      _c("div", { staticClass: "prize-content-left" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/minor-gold.webp"),
          },
        }),
        _c("div", [_vm._v("Vàng Doji 999.9 (3.75g)")]),
      ]),
      _c("div", { staticClass: "prize-content-mid" }, [_vm._v("HOẶC")]),
      _c("div", { staticClass: "prize-content-right" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/minor-prize.webp"),
          },
        }),
        _c("div", [_vm._v("PS5 mỏng")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-header mini" }, [
      _c("div", [_vm._v("Phần thưởng Mini:")]),
      _c("div", [_vm._v("có 8 giải")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "prize-content" }, [
      _c("div", { staticClass: "prize-content-left" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/mini-gold.webp"),
          },
        }),
        _c("div", [_vm._v("Vàng Doji 999.9 (1.875g)")]),
      ]),
      _c("div", { staticClass: "prize-content-mid" }, [_vm._v("HOẶC")]),
      _c("div", { staticClass: "prize-content-right" }, [
        _c("img", {
          staticClass: "img-small",
          attrs: {
            src: require("@/assets/images/game-help/jackpot/physical/mini-prize.webp"),
          },
        }),
        _c("div", [_vm._v("Nintendo Switch (Lite)")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticStyle: { "list-style-type": "none" } }, [
      _c("li", [
        _vm._v(
          " 1. Người chiến thắng sẽ nhận được thông báo qua hộp thư email. Vui lòng làm theo hướng dẫn được cung cấp trong email để nhận giải thưởng của bạn. "
        ),
      ]),
      _c("li", [
        _vm._v(
          "2. Giải thưởng không được nhận trong vòng 45 ngày sẽ bị hủy bỏ."
        ),
      ]),
      _c("li", [_vm._v("3. Thông tin người trúng giải sẽ được bảo mật.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }